module.exports = __webpack_public_path__ + "img/icon_wa.feb50688.svg";